(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-gift-duo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alfuzon-gift-duo')) customElements.define('alfuzon-gift-duo', class extends HTMLElement {
  connectedCallback() {
    if(this.controller) return;
    this.controller=new AbortController();const events={signal:this.controller.signal};
    this.variants=JSON.parse(this.querySelector('[data-gd-variants]').textContent);this.teas=JSON.parse(this.querySelector('[data-gd-teas]').textContent);
    this.form=this.querySelector('form');this.idInput=this.querySelector('[data-gd-variant]');this.groups=[...this.querySelectorAll('[data-gd-group]')];this.quantity=this.form.querySelector('[name="quantity"]');this.message=this.querySelector('.gd-message');this.sticky=this.querySelector('.gd-sticky');this.busy=false;
    if(this.groups.length!==2||!this.variants.length) return;
    this.groups.forEach(group=>group.disabled=false);
    this.pick=(i,value)=>this.groups[i].querySelectorAll('[data-gd-option]').forEach(input=>input.checked=input.value===value);
    this.sync=()=>{
      const values=this.groups.map(group=>group.querySelector('input:checked')?.value||'');const variant=this.variants.find(v=>v.options.every((value,i)=>value===values[i]));
      this.selected=variant;this.idInput.value=variant?String(variant.id):'';
      const candidates=this.variants.filter(v=>v.options.every((value,i)=>!values[i]||value===values[i]));const minimum=candidates.reduce((lowest,v)=>!lowest||v.price<lowest.price?v:lowest,null);
      const priceText=variant?.money||(minimum?`${this.dataset.fromLabel} ${minimum.money}`:'');this.querySelectorAll('[data-gd-price]').forEach(el=>el.textContent=priceText);
      values.forEach((value,i)=>{const tea=this.teas.find(t=>t.name===value);const preview=this.querySelector(`[data-gd-preview="${i}"]`);const img=preview.querySelector('img');img.hidden=!tea;preview.classList.toggle('is-selected',!!tea);preview.querySelector('[data-gd-name]').textContent=value||this.dataset.chooseBoth;preview.querySelector('[data-gd-mrp]').textContent=tea?.mrp||'';this.groups[i].querySelector('[data-gd-slot-mrp]').textContent=tea?.mrp||'';if(tea){img.src=tea.image;img.alt=tea.name;}});
      this.querySelector('[data-gd-sticky-pair]').textContent=values.every(Boolean)?values.join(' + '):this.dataset.chooseBoth;
      const availability=this.querySelector('[data-gd-availability]');availability.textContent=!variant?this.dataset.chooseBoth:variant.available?'':availability.dataset.unavailable;
      this.querySelectorAll('[data-gd-add],[data-gd-buy],[data-gd-sticky-buy]').forEach(button=>{button.disabled=!variant?.available||this.busy;button.setAttribute('aria-busy',String(this.busy));});
      this.querySelectorAll('.gd-pairing').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.gdFirst===values[0]&&button.dataset.gdSecond===values[1])));
      const url=new URL(location.href);if(variant)url.searchParams.set('variant',String(variant.id));else url.searchParams.delete('variant');history.replaceState(null,'',url);
    };
    this.querySelectorAll('[data-gd-option]').forEach(input=>input.addEventListener('change',()=>{this.message.textContent='';this.sync();},events));
    this.querySelectorAll('[data-gd-step]').forEach(button=>button.addEventListener('click',()=>{this.quantity.value=String(Math.max(1,(parseInt(this.quantity.value,10)||1)+Number(button.dataset.gdStep)));this.quantity.dispatchEvent(new Event('change',{bubbles:true}));},events));
    this.querySelectorAll('.gd-pairing').forEach(button=>button.addEventListener('click',()=>{this.pick(0,button.dataset.gdFirst);this.pick(1,button.dataset.gdSecond);this.message.textContent='';this.sync();this.groups[0].querySelector('input:checked')?.focus();},events));
    this.querySelectorAll('.gd-thumbnail').forEach(button=>button.addEventListener('click',()=>{const image=this.querySelector('.gd-current-image');image.removeAttribute('srcset');image.src=button.dataset.imageUrl;image.alt=button.dataset.imageAlt;this.querySelectorAll('.gd-thumbnail').forEach(th=>th.setAttribute('aria-pressed',String(th===button)));},events));
    this.form.addEventListener('submit',async event=>{
      event.preventDefault();if(this.busy||!this.selected?.available||!this.form.reportValidity())return;
      const buy=event.submitter?.hasAttribute('data-gd-buy');this.busy=true;this.message.textContent='';this.sync();
      try{const response=await fetch(`${this.dataset.cartUrl}/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.selected.id,quantity:Number(this.quantity.value)}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.dataset.error);if(buy){location.assign('/checkout');return;}this.message.textContent=this.dataset.added;location.assign(this.dataset.cartUrl);}
      catch(error){this.message.textContent=error.message||this.dataset.error;}
      finally{this.busy=false;this.sync();}
    },events);
    this.querySelector('[data-gd-sticky-buy]').addEventListener('click',()=>this.form.requestSubmit(this.querySelector('[data-gd-buy]')),events);
    this.observer=new IntersectionObserver(entries=>{this.sticky.hidden=entries[0].isIntersecting;document.body.classList.toggle('gd-active-sticky',!this.sticky.hidden);},{threshold:0,rootMargin:'-80px 0px 0px 0px'});this.observer.observe(this.querySelector('.gd-purchase'));
    this.offset=()=>{const bar=document.querySelector('#PBarNextFrameWrapper');const rect=bar?.getBoundingClientRect();const px=rect&&rect.height>0&&rect.top<innerHeight?Math.max(0,innerHeight-rect.top):0;document.body.style.setProperty('--gd-preview-offset',`${px}px`);};window.addEventListener('resize',this.offset,events);this.previewObserver=new MutationObserver(this.offset);this.previewObserver.observe(document.body,{childList:true});
    this.sync();this.offset();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.previewObserver?.disconnect();this.controller=null;document.body.classList.remove('gd-active-sticky');document.body.style.removeProperty('--gd-preview-offset');}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-about-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const link = event.target.closest('.ao-story-copy a[href^="#AsStory-"]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const header = document.querySelector(mobile ? '.rf-header-main' : '.rf-nav');
  const top = target.getBoundingClientRect().top + window.scrollY - (header?.offsetHeight || 0) - 24;
  window.scrollTo({top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
